<script setup lang="ts">
const emit = defineEmits(['close'])

const props = defineProps<{
  open: boolean
  class?: string
}>()
</script>

<template>
  <ClientOnly>
    <HeadlessDialog
      :open="open"
      @close="emit('close')"
      class="fixed inset-0 z-20 py-16 sm:py-24 px-4 grid"
    >
      <HeadlessDialogOverlay
        class="fixed inset-0 bg-black bg-opacity-60 backdrop-blur"
      />
      <div
        :class="[
          'relative max-h-full overflow-auto bg-white rounded-lg shadow-xl w-full max-w-2xl self-center justify-self-center',
          props.class,
        ]"
      >
        <slot />
      </div>
    </HeadlessDialog>
  </ClientOnly>
</template>
